import {useEffect} from "react";
import {track} from "../../services/Analytics";
import { useLocation } from "react-router-dom";

// in some cases component is rendered twice because loading state appears and disappears
// => only send tracking event, when page changed
let lastTrackingPath: string|undefined = undefined;

export const AnalyticsTracking = (props: {page: string}) => {
 /* if(typeof AnalyticsTranslations[props.page] === 'undefined') {
    throw 'Missing Translation in Tracking for: ' + props.page;
  }*/
  const location = useLocation();
  useEffect(() => {
    if(location.pathname !== lastTrackingPath) {
      lastTrackingPath = location.pathname;
      track(props.page);
    }
  }, [location.pathname, props.page]);
  return null;
};